module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sink"
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "breakafter"
  }, [_c('p', {
    staticClass: "center "
  }, [_c('em', [_vm._v("For Owen")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "sink"
  }, [_c('p', {
    staticClass: "left "
  }, [_c('b', [_vm._v("welsh,")]), _vm._v(" "), _c('em', [_vm._v("v.")]), _vm._v(" Also "), _c('b', [_vm._v("welch")]), _vm._v(" [Of obscure origin]")])]), _vm._v(" "), _c('blockquote', {
    staticClass: "indent3"
  }, [_c('p', {
    staticClass: "hang "
  }, [_c('b', [_vm._v("1. ")]), _c('em', [_vm._v("trans.")]), _vm._v(" To swindle (a person) out of money laid as a bet.")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_c('b', [_vm._v("2. ")]), _c('em', [_vm._v("intr.")]), _vm._v(" Const. "), _c('em', [_vm._v("on.")]), _vm._v(" To fail to carry out one’s promise to (a person); to fail to keep (an obligation).")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "indent3"
  }, [_c('p', {
    staticClass: "right "
  }, [_c('em', [_vm._v("—Oxford English Dictionary,")]), _vm._v(" 1928")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4731556","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 66
// module chunks = 0